import { render } from "./CIS-Header.vue?vue&type=template&id=4fc37d48"
import script from "./CIS-Header.vue?vue&type=script&lang=js"
export * from "./CIS-Header.vue?vue&type=script&lang=js"

import "./CIS-Header.vue?vue&type=style&index=0&id=4fc37d48&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__